import i18n from 'i18next'

export default function (values, errorKey, valuePrefixKey = '') {
  return i18n.t(errorKey, {
    values: values
      .split(', ')
      .map((key) => i18n.t(valuePrefixKey + key))
      .join(', '),
  })
}
